/* ✨ IAS SHINY CART engine (FINAL BOSS ③, Captain 10-15). Paints every [data-shy-ladder] and [data-shy-ship], wires every
   [data-shy-add], and keeps PDP cards on the shopper's colour. Reads assets/ias-rates.json ONLY (mode-paired, window-honest);
   never hand-types a percentage or a threshold. Shopify's own cart totals are the truth for money (post-discount total).
   Fails closed: no rates → ladder stays hidden and ship lines stay empty. Runs once; repaints whenever Dawn re-renders
   the drawer / cart sections (MutationObserver) or the cart changes (cart:updated / our own adds). */
(function () {
  'use strict';
  if (window.__iasShiny) return;
  window.__iasShiny = 1;

  var me = document.currentScript;
  var RATES_URL = me && me.dataset.rates;
  var rates = null, cartCache = null, cartAt = 0;

  function money(c) { var n = c / 100; return (window.IAS_SYM || '$') + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function getJSON(u) {
    return fetch(u, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function block() { return rates ? (rates[rates.mode] || {}) : {}; }
  function strings() { return block().strings || {}; }
  function inWindow() {
    if (!rates) return false;
    if (rates.mode === 'off') return false;
    if (rates.mode !== 'event') return true;
    if (/[?&]ias-ladder-preview=1/.test(location.search)) return true;
    var w = rates.window || {}, n = Date.now();
    if (w.starts_at && n < Date.parse(w.starts_at)) return false;
    if (w.ends_at && n > Date.parse(w.ends_at)) return false;
    return true;
  }
  function tiers() { return inWindow() ? (block().tiers || []) : []; }
  function maxPct() { return tiers().reduce(function (m, t) { return Math.max(m, t.pct || 0); }, 0); }
  function threshold() { return Math.round((rates && rates.free_ship_threshold || 0) * 100); }
  /* always the live cart — a cached snapshot painted stale gaps after Dawn's own Add (10-15 canary finding) */
  function cart() {
    return getJSON('/cart.js').then(function (c) { cartCache = c; cartAt = Date.now(); return c; });
  }

  /* 🚚 NEXT BEST STEP (FULL SEND add, Captain 10-16): no second bar. The free-shipping point rides ON the ladder track as a
     🚚 milestone, and the tier line + ship line become ONE line computed from the harmony pick the chord row is offering
     (its rendered cards: real variant prices, third before fifth). Projection = the next tier's % on the WHOLE cart and
     any non-tier discount kept: a LOWER bound on the real total, so "+ free US shipping" is only said when guaranteed. */
  function tierAt(n) { var t = null; tiers().forEach(function (x) { if (n >= x.min_keys) t = x; }); return t; }
  function tierName(t) { return t ? String(t.name || '').split(' ')[0] + ' ' + t.pct + '% off' : ''; }
  function picksFor(el) {
    var sc = el.closest('cart-drawer, #MainContent, main') || document, ORD = { third: 0, fifth: 1 };
    return [].slice.call(sc.querySelectorAll('[data-fx-part="chord"] [data-fx-card][data-fx-role]')).filter(function (c) {
      if (c.hidden || c.closest('[hidden]') || ORD[c.dataset.fxRole] == null) return false;
      var b = c.querySelector('[data-shy-add]'); return b && !b.classList.contains('is-in') && !b.disabled;
    }).sort(function (a, b) { return ORD[a.dataset.fxRole] - ORD[b.dataset.fxRole]; }).map(function (c) {
      var pr = c.querySelector('[data-fx-price]');
      return { key: String(c.dataset.title || '').split(' ')[0], role: c.dataset.fxRole,
        price: Math.round(parseFloat(((pr && pr.textContent) || '0').replace(/[^0-9.]/g, '')) * 100) || 0 };
    });
  }
  function pickSig(el) { return picksFor(el).map(function (p) { return p.key + p.role + p.price; }).join(','); }
  function nextStep(el, keys, total, orig, usd) {
    var T = usd ? threshold() : 0, ps = picksFor(el), s = strings();
    var nowT = tierAt(keys), nonTier = Math.max(0, (orig - total) - Math.round(orig * (nowT ? nowT.pct : 0) / 100));
    function proj(j) {                                      // lower bound on the total after adding the first j picks
      var add = 0; for (var i = 0; i < j; i++) add += ps[i].price;
      var t = tierAt(keys + j); return Math.floor((orig + add) * (100 - (t ? t.pct : 0)) / 100) - nonTier;
    }
    var at = 0, lit = false;                                // 🚚 sits on the key stop where $119 is reached
    if (T) {
      if (total >= T) { at = keys; lit = true; }
      else { for (var j = 1; j <= ps.length; j++) if (proj(j) >= T) { at = keys + j; break; } }
    }
    var text, gap = T - total;
    if (ps.length) {
      var p = ps[0], t1 = tierAt(keys + 1);
      text = 'Add ' + p.key + ' (the ' + p.role + ')' + (t1 ? ' → ' + tierName(t1) : '');
      if (T) text += total >= T ? ' · free US shipping is on ✓' : proj(1) >= T ? ' + free US shipping' : ' · ' + money(gap) + ' to free shipping';
    } else {
      text = s[keys >= 4 ? 'k4' : ('k' + keys)] || '';
      if (T) text += (text ? ' · ' : '') + (total >= T ? 'free US shipping is on ✓' : money(gap) + ' to free shipping');
    }
    return { text: text, at: at, lit: lit, far: !!T && !at };
  }
  (function () { var st = document.createElement('style'); st.textContent =
    '.shy-ladder__track.shy-shipbar{display:block;margin:10px 6px 4px;padding:0 0 22px;border:0;border-radius:0;overflow:visible;background:none}' +
    '.shy-shipbar__rail{position:relative;height:4px;border-radius:99px;background:#E2E2DE}' +
    '.shy-shipbar__fill{position:absolute;left:0;top:0;bottom:0;border-radius:99px;background:#111;transition:width .35s ease}' +
    /* the ONLY moment rainbow shows on a bar: a reward just unlocked (free shipping / a new tier) → brief shimmer, then ink */
    '@keyframes iasShimmer{0%{background-position:0 0}100%{background-position:-200% 0}}' +
    '.is-shimmer{background:var(--shy-rainbow,linear-gradient(90deg,#ff4878,#ffaa3c,#fae650,#50dc8c,#46aaff,#9664ff))!important;background-size:200% 100%!important;animation:iasShimmer 1.4s ease-in-out 1}' +
    '@media (prefers-reduced-motion:reduce){.is-shimmer{animation:none}}' +
    '.shy-shipbar__goal{position:absolute;right:-6px;top:50%;transform:translateY(-55%);font-size:1.7rem;line-height:1;filter:grayscale(1);opacity:.55}.shy-shipbar__goal.is-on{filter:none;opacity:1}' +
    '.shy-tickm{position:absolute;top:-4px;bottom:-4px;width:2px;margin-left:-1px;border-radius:2px;background:rgba(0,0,0,.45)}.shy-tickm.is-on{background:#111}' +
    '.shy-tickm b{position:absolute;top:19px;left:50%;transform:translateX(-50%);white-space:nowrap;font:700 1.05rem/1 var(--shy-body,inherit);color:var(--shy-grey,#6e6e6e)}' +
    '.shy-tickm.is-up b{top:auto;bottom:17px}.shy-ladder__track.shy-shipbar:has(.is-up){margin-top:24px}.shy-tickm.is-on b{color:#111}.shy-tickm.is-l b{left:0;transform:none}.shy-tickm.is-r b{left:auto;right:0;transform:none}' +
    '.shy-ladder__copy.is-ship-head{font:800 1.5rem/1.2 var(--shy-head,inherit);letter-spacing:-.01em}.shy-ladder__copy.is-free-step{color:#1a7f37}'; document.head.appendChild(st); })();

  /* ② LADDER — segmented 1·2·3·4+, continuous JER-FLARE rainbow across the filled segments */
  function paintLadder(el) {
    if (!rates) return;
    var keys = +el.dataset.keys || 0, total = +el.dataset.total || 0, orig = +el.dataset.original || 0;
    var usd = (el.dataset.currency || 'USD') === 'USD';
    var ts = tiers(), s = strings();
    var copy = el.querySelector('[data-shy-copy]'), track = el.querySelector('[data-shy-track]');
    var ship = el.querySelector('[data-shy-lship]'), tot = el.querySelector('[data-shy-ltotal]');
    /* LAST COUSIN ① (Captain 10-16): the drawer HEADLINE is free shipping — one bold line + ONE full-width bar (post-discount
       cart total vs the free-ship threshold). Duo/Trio/Ensemble sit as TICKS on that same bar, placed at the projected total
       each tier is reached along the harmony picks (lower-bound math). The next-best-step line stays below. Never two bars.
       Non-USD carts (no US free-ship offer) keep the segmented key ladder. */
    var T = usd ? threshold() : 0, k = keys >= 4 ? 'k4' : ('k' + keys), ps = picksFor(el), nowT = tierAt(keys);
    var nonTier = Math.max(0, (orig - total) - Math.round(orig * (nowT ? nowT.pct : 0) / 100));
    function proj(j) { var add = 0; for (var i = 0; i < j; i++) add += ps[i].price; var t = tierAt(keys + j); return Math.floor((orig + add) * (100 - (t ? t.pct : 0)) / 100) - nonTier; }
    function short(t) { return String(t.name || '').split(' ')[0]; }
    /* AOV R1 FINAL (Deck 10-20): the tier nudge, plain — 1 key → "Add 1 key → 10%", 2 → 15%, 3 → 20%, 4+ celebrates.
       Percentages from ias-rates.json; key count = ladder-eligible keys (server-counted). Picks live in the smart row below. */
    var line = '', nx = null, top = ts[ts.length - 1];
    ts.forEach(function (t) { if (keys < t.min_keys && (!nx || t.min_keys < nx.min_keys)) nx = t; });
    if (keys >= 1 && nx) line = 'Add ' + (nx.min_keys - keys) + ' key' + (nx.min_keys - keys > 1 ? 's' : '') + ' → ' + nx.pct + '%';
    else if (keys >= 1 && top && keys >= top.min_keys) line = short(top) + ' — ' + top.pct + '% off every key 🎉';
    if (T) {
      var free = total >= T, fill = Math.min(100, Math.round(total * 1000 / T) / 10), ticks = [];
      copy.textContent = free ? '🎉 Free US shipping unlocked!' : 'You\'re ' + money(T - total) + ' from free US shipping 🚚';   /* GIFT ENGINE 10-21: AOV nudge copy (Dispatch) */
      copy.classList.toggle('is-free-step', free); copy.classList.add('is-ship-head');
      if (nowT) ticks.push({ pos: free ? 100 : fill, label: short(nowT) + ' ✓', on: true });
      if (!free) {
        var prev = nowT;
        for (var j = 1; j <= ps.length; j++) {
          var tj = tierAt(keys + j); if (!tj || tj === prev) continue; prev = tj;
          ticks.push({ pos: Math.min(100, Math.round(proj(j) * 1000 / T) / 10), label: short(tj) + ' ' + tj.pct + '%', on: false });
        }
      }
      track.className = 'shy-ladder__track shy-shipbar'; track.style.removeProperty('--shy-stops');
      track.innerHTML = '<div class="shy-shipbar__rail"><i class="shy-shipbar__fill" style="width:' + fill + '%"></i>' +
        ticks.sort(function (a, b) { return a.pos - b.pos; }).map(function (t, i, all) {
          var edge = t.pos >= 88 ? ' is-r' : t.pos <= 12 ? ' is-l' : '';
          var up = i > 0 && t.pos - all[i - 1].pos < 26 && !all[i - 1].up; t.up = up;      // crowded → this label rides above the rail
          return '<span class="shy-tickm' + (t.on ? ' is-on' : '') + edge + (up ? ' is-up' : '') + '" style="left:' + t.pos + '%"><b>' + t.label + '</b></span>';
        }).join('') +
        '<span class="shy-shipbar__goal' + (free ? ' is-on' : '') + '" title="Free US shipping at ' + money(T) + '">🚚</span></div>';
      track.hidden = false;
      /* reward moment: free shipping just reached, or a higher tier just reached → shimmer once, then rest as ink */
      try {
        var rw = { free: free, pct: nowT ? nowT.pct : 0 }, last = JSON.parse(sessionStorage.getItem('ias-reward') || 'null');
        if (last && ((rw.free && !last.free) || rw.pct > last.pct) && !el.dataset.shimmered) {
          var fe = track.querySelector('.shy-shipbar__fill'); el.dataset.shimmered = '1';
          if (fe) { fe.classList.add('is-shimmer'); setTimeout(function () { fe.classList.remove('is-shimmer'); }, 1500); }
          setTimeout(function () { sessionStorage.setItem('ias-reward', JSON.stringify(rw)); }, 300);   // drawer + /cart copies both shimmer
        } else if (!last || rw.free !== last.free || rw.pct !== last.pct) sessionStorage.setItem('ias-reward', JSON.stringify(rw));
      } catch (e) {}
    } else if (ts.length) {
      var stops = [{ n: 1, label: '1', pct: 0 }].concat(ts.map(function (t, i) {
        return { n: t.min_keys, label: t.min_keys + (i === ts.length - 1 ? '+' : ''), pct: t.pct };
      }));
      track.className = 'shy-ladder__track'; track.style.setProperty('--shy-stops', stops.length);
      track.innerHTML = stops.map(function (st, i) {
        var pos = stops.length > 1 ? Math.round(i * 100 / (stops.length - 1)) : 0;
        return '<div class="shy-ladder__seg' + (keys >= st.n ? ' is-on' : '') + '" style="--shy-pos:' + pos + '%">' +
          '<span>' + st.label + '</span>' + (st.pct ? '<em>' + st.pct + '%</em>' : '') + '</div>';
      }).join('');
      copy.textContent = s[k] || ''; copy.classList.remove('is-free-step');
      track.hidden = false;
    } else { copy.textContent = ''; track.innerHTML = ''; track.hidden = true; }
    /* the next best step, below the bar */
    ship.textContent = line; ship.classList.toggle('is-free', / free US shipping$/.test(line)); ship.hidden = !line;
    if (orig > total) {
      /* AOV R1 (10-20): "You saved $X" = Shopify's own discount on this cart (original_total_price − total_price), to the cent */
      var sv = orig - total, cents = function (c) { return (window.IAS_SYM || '$') + (c / 100).toFixed(2).replace(/\.00$/, ''); };
      tot.innerHTML = '<span class="shy-ladder__saved">You saved <b>' + cents(sv) + '</b></span><span class="shy-ladder__yp"> · <s>' + cents(orig) + '</s>' + cents(total) + '</span>';
      tot.dataset.saved = sv;
      tot.hidden = false;
    } else { tot.innerHTML = ''; tot.hidden = true; }
    el.hidden = !(copy.textContent || !ship.hidden || !tot.hidden);
    el.dataset.painted = [keys, total, orig, rates.mode, pickSig(el)].join('|');
  }

  /* ④ HONEST SHIP MATH on every card — from the REAL post-discount cart total (Shopify's number).
     "unlocks free shipping" is only claimed when it is GUARANTEED: even if the strongest ladder tier hit the whole
     cart + this item, the total would still clear the threshold. Otherwise we state today's gap, nothing more. */
  /* PDP cards mirror the LIVE cart (math pt 3): added from anywhere (drawer row, other tab) → "In your chord ✓";
     removed → back to "+ Add". Server render only knows the cart at page load. */
  function syncCardStates(c) {
    if (!c) return;
    var ids = {}; (c.items || []).forEach(function (i) { ids[i.product_id] = 1; });
    document.querySelectorAll('[data-shy-add][data-shy-pid]').forEach(function (b) {
      if (b.getAttribute('aria-busy') === 'true') return;
      var inCart = !!ids[b.dataset.shyPid];
      if (inCart === b.classList.contains('is-in')) return;
      b.classList.toggle('is-in', inCart);
      b.disabled = inCart;
      if (inCart) { b.setAttribute('aria-disabled', 'true'); b.innerHTML = (b.dataset.shyInLabel || 'In your chord') + ' <span class="shy-tick" aria-hidden="true"></span>'; }
      else { b.removeAttribute('aria-disabled'); b.textContent = b.dataset.shyAddLabel || '+ Add'; }
    });
  }

  function paintShips(c) {
    syncCardStates(c);
    var T = threshold(); if (!T || !c) return;
    var usd = (c.currency || 'USD') === 'USD';
    var gap = T - c.total_price, mp = maxPct();
    document.querySelectorAll('[data-shy-ship]').forEach(function (el) {
      if (!usd) { el.textContent = ''; return; }
      var price = +el.dataset.price || 0, txt, free = false;
      if (gap <= 0) { txt = 'Free US shipping is on'; free = true; }
      else if (Math.floor((c.original_total_price + price) * (100 - mp) / 100) >= T) { txt = 'Adding this unlocks free US shipping'; free = true; }
      else { txt = (strings().ship_gap || '+{amt} to free shipping').replace('{amt}', money(gap)); }
      if (el.textContent !== txt) el.textContent = txt;
      el.classList.toggle('is-free', free);
      el.dataset.shyPs = '1';
    });
  }

  function paintAll(forceCart) {
    document.querySelectorAll('[data-shy-ladder]').forEach(function (el) {
      var sig = [el.dataset.keys, el.dataset.total, el.dataset.original, rates && rates.mode, pickSig(el)].join('|');
      if (el.dataset.painted !== sig) paintLadder(el);
    });
    /* fetch the cart only when the cart changed (forced) or a freshly rendered ship line is still unpainted */
    if (forceCart ? document.querySelector('[data-shy-ship]') : document.querySelector('[data-shy-ship]:not([data-shy-ps])')) cart().then(paintShips);
  }

  /* PDP colour-follow: re-pick the card's variant from the shopper's colour (same dual-supply order as the server) */
  function currentColour() {
    var fs = document.querySelector('variant-selects fieldset, variant-radios fieldset');
    var r = fs && fs.querySelector('input[type=radio]:checked');
    if (r) return r.value;
    var s = document.querySelector('variant-selects select');
    return s ? s.value : null;
  }
  function repickCards() {
    var colour = currentColour(); if (!colour) return;
    document.querySelectorAll('[data-shy-card][data-shy-colour-follow="1"]').forEach(function (card) {
      var vs; try { vs = JSON.parse(card.querySelector('[data-shy-variants]').textContent); } catch (e) { return; }
      if (!vs || !vs.length) return;
      var pick = vs.find(function (v) { return v.c === colour && v.now; }) || vs.find(function (v) { return v.c === colour; }) ||
        vs.find(function (v) { return v.now; }) || vs[0];
      var btn = card.querySelector('[data-shy-add]');
      if (!btn || btn.classList.contains('is-in')) return;
      btn.dataset.shyAdd = pick.id;
      var badge = card.querySelector('[data-shy-badge]');
      badge.textContent = pick.now ? 'Ships Now' : 'Made for You · 2–3 wks';
      badge.classList.toggle('shy-badge--now', pick.now);
      badge.classList.toggle('shy-badge--mfy', !pick.now);
      card.querySelector('[data-shy-price]').textContent = pick.pm;
      var ship = card.querySelector('[data-shy-ship]'); if (ship) ship.dataset.price = pick.p;
    });
    cart().then(paintShips);
  }

  /* one-tap Add — native /cart/add.js; drawer re-render (and clear Dawn's is-empty, the 10-15 blank-drawer lesson).
     /cart page: re-render the cart sections in place (FUSION 10-15) — no reload, so the shopper keeps their spot AND the
     ad pixels' batched add_to_cart (GA4) flushes instead of dying with the page. Reload only if the sections can't swap. */
  function srcProp(b) { var h = b.closest && b.closest('[data-ias-src]'), o = h ? { _ias_src: h.getAttribute('data-ias-src') } : {}; if (b.closest && b.closest('cart-drawer')) o._offer_source = 'cart-nudge'; else if (b.closest && b.closest('#ias-key-focus, #ias-chord-builder, [data-ics-card]')) o._offer_source = 'chord'; return o; }   // AOV R1: drawer picks measured
  function swapSection(html, sel) {
    var fresh = new DOMParser().parseFromString(html || '', 'text/html').querySelector(sel), old = document.querySelector(sel);
    if (!fresh || !old) return false;
    old.innerHTML = fresh.innerHTML; return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-shy-add]');
    if (!b || b.disabled || b.classList.contains('is-in')) return;
    e.preventDefault();
    var label = b.innerHTML;
    b.setAttribute('aria-busy', 'true'); b.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = /^\/cart\/?$/.test(location.pathname);
    var mainItems = document.getElementById('main-cart-items'), mainFoot = document.getElementById('main-cart-footer');
    var secs = onCartPage && mainItems && mainFoot ? [mainItems.dataset.id, mainFoot.dataset.id, 'cart-icon-bubble'].join(',') : 'cart-drawer,cart-icon-bubble';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      /* KPI (FULL SEND 10-16): the surface rides as a hidden line property → attach rate by surface is readable from orders */
      body: JSON.stringify({ items: [{ id: Number(b.dataset.shyAdd), quantity: 1, properties: srcProp(b) }], sections: secs, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state && state.status) { b.innerHTML = label; b.disabled = false; b.removeAttribute('aria-busy'); return; }
      cartCache = null;
      b.removeAttribute('aria-busy');
      b.classList.add('is-in');
      b.innerHTML = (b.dataset.shyInLabel || 'In your chord') + ' <span class="shy-tick" aria-hidden="true"></span>';
      if (onCartPage) {
        var S = state.sections || {};
        var ok = mainItems && mainFoot && swapSection(S[mainItems.dataset.id], '#main-cart-items .js-contents') &&
          swapSection(S[mainFoot.dataset.id], '#main-cart-footer .js-contents');
        if (!ok) { location.reload(); return; }
        var bub = document.getElementById('cart-icon-bubble');
        var bf = S['cart-icon-bubble'] && new DOMParser().parseFromString(S['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bub && bf) bub.innerHTML = bf.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return;
      }
      if (drawer && drawer.renderContents && state.sections) { drawer.renderContents(state); drawer.classList.remove('is-empty'); }
      else { location.href = '/cart'; }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function () { b.innerHTML = label; b.disabled = false; b.removeAttribute('aria-busy'); });
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(repickCards, 80);
  });
  document.addEventListener('cart:updated', function () { cartCache = null; setTimeout(function () { paintAll(true); }, 60); });
  /* DIAL-IN 10-16: the PDP card's "+$X to free shipping" must be the LIVE cart — a page restored from the back/forward cache,
     a cart changed in another tab, or a drawer opened later all repaint from /cart.js (Captain's phone walk: +$44 on a free-ship cart) */
  window.addEventListener('pageshow', function (e) { if (e.persisted && rates) paintAll(true); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && rates) paintAll(true); });
  window.addEventListener('focus', function () { if (rates) paintAll(true); });

  function boot() {
    if (!RATES_URL) return;
    getJSON(RATES_URL).then(function (r) {
      rates = r; if (!r) return;
      paintAll(true);
      /* Dawn's own Add to cart / qty changes publish on its pub-sub channel, not a DOM event — listen there too */
      try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { paintAll(true); }, 150); }); } catch (e) {}
      var t = null;
      new MutationObserver(function (muts) {
        var external = muts.some(function (m) { var n = m.target; return !(n.closest && n.closest('[data-shy-ladder],[data-shy-ship]')); });
        if (!external) return;
        clearTimeout(t); t = setTimeout(function () { paintAll(false); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
